import { WaiverEventType, WaiverEvents } from '@prisma/client';
import { format } from 'date-fns';
import { ModalData, SectionRow } from '../../interfaces';
import { WaiverRequestWithCustomerAndEvents } from '../../types/waivers';
import { getFullName } from '../../helpers/global';

function getActionText(eventType: WaiverEventType) {
  switch (eventType) {
    case WaiverEventType.CANCELED:
      return 'Waiver canceled';
    case WaiverEventType.COMPLETED:
      return 'Waiver signed';
    case WaiverEventType.REMINDER:
      return 'Reminder sent';
    case WaiverEventType.SCHEDULED:
      return 'Waiver scheduled';
    case WaiverEventType.VIEWED:
      return 'Waiver viewed';
    case WaiverEventType.SENT:
      return 'Waiver sent';
    case WaiverEventType.REACTIVATED:
      return 'Waiver reactivated';
    default:
      return '';
  }
}

function getEventRows(event: WaiverEvents, customerName: string) {
  const actionText = getActionText(event.type);
  const timestamp = format(new Date(event.createdAt), 'MMMM dd, yyyy, h:mm a');
  const { ip } = event;

  const rows: SectionRow[] = [
    {
      type: 'TEXT',
      label: 'Action',
      value: [actionText],
    },
  ];

  if (event.type === 'VIEWED' || event.type === 'COMPLETED') {
    rows.push(
      {
        type: 'TEXT',
        label: 'User',
        value: [customerName],
      },
      {
        type: 'TEXT',
        label: 'IP Address',
        value: [ip || ''],
      },
    );
  }

  rows.push({
    type: 'TEXT',
    label: 'Timestamp',
    value: [timestamp],
  });

  return rows;
}

// Set modal data based on the waiver data
export function createModalData(waiver: WaiverRequestWithCustomerAndEvents) {
  const customerName = getFullName({
    firstName: waiver.customer.user.firstName,
    lastName: waiver.customer.user.lastName,
  });

  const newModalData = {
    name: 'Waiver Activity',
    sections: waiver.events.map(event => ({
      name: '',
      rows: getEventRows(event, customerName),
    })),
  };

  return newModalData as ModalData;
}
